import {
  AlertDialogWithActionCancel,
  AlertDialogWithActionContent,
  AlertDialogWithActionDescription,
  AlertDialogWithActionFooter,
  AlertDialogWithActionHeader,
  AlertDialogWithActionSubmit,
  AlertDialogWithActionTitle,
} from '@/components/alert-dialog-with-action';

export function ExportSkuDialogContent() {
  return (
    <AlertDialogWithActionContent>
      <AlertDialogWithActionHeader>
        <AlertDialogWithActionTitle>Export all SKUs?</AlertDialogWithActionTitle>
        <AlertDialogWithActionDescription>
          All SKUs in your account will be exported in CSV format and downloaded to your computer.
        </AlertDialogWithActionDescription>
      </AlertDialogWithActionHeader>
      <AlertDialogWithActionFooter>
        <AlertDialogWithActionCancel>Cancel</AlertDialogWithActionCancel>
        <AlertDialogWithActionSubmit>Confirm</AlertDialogWithActionSubmit>
      </AlertDialogWithActionFooter>
    </AlertDialogWithActionContent>
  );
}
